import { render, staticRenderFns } from "./form-payments.vue?vue&type=template&id=4196bbe0&"
import script from "./form-payments.vue?vue&type=script&lang=js&"
export * from "./form-payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports